import { Avatar, AvatarFallback, AvatarImage } from '@e2n/ui';
import { Markierung } from '@/domain/termine/components';
import { markierungMapper } from '@/domain/termine/shared/types';
import { Arbeitszeit } from '@/domain/termine/shared/types/Arbeitszeit';
import { formatDateTimeRange } from '@/domain/termine/shared/utils/formatDateTime';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function ArbeitszeitInfo({ arbeitszeit }: { arbeitszeit: Arbeitszeit }) {
  return (
    <div className="flex items-center gap-2">
      <Avatar className="w-9 h-9">
        <AvatarImage
          src={arbeitszeit.mitarbeiter.bildUrl ?? undefined}
          alt={`${arbeitszeit.mitarbeiter.vorname} ${arbeitszeit.mitarbeiter.nachname}`}
        />
        <AvatarFallback>
          <FontAwesomeIcon icon={faUser} size="lg" />
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col">
        <span className="text-neutrals-900 text-sm">
          {arbeitszeit.mitarbeiter.vorname} {arbeitszeit.mitarbeiter.nachname}
        </span>
        <div className="flex items-center gap-1 text-xs font-normal text-neutrals-700">
          {arbeitszeit.arbeitsbereich.markierung && (
            <Markierung
              color={
                markierungMapper[arbeitszeit.arbeitsbereich.markierung].base
              }
            />
          )}
          {arbeitszeit.arbeitsbereich.name} ⋅{' '}
          {formatDateTimeRange(
            arbeitszeit.datum,
            arbeitszeit.beginn,
            arbeitszeit.ende,
          )}
        </div>
      </div>
    </div>
  );
}
